import {LogoCoverFormItem} from './logo-cover-form-item/logo-cover-form-item';

export function LogoWidget(): JSX.Element {
    return <LogoCoverFormItem />;
}
